import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        searchP:{
            jobgroup:'',//任务分组
            jobname:'',//任务名称
            jobstatus:'',//任务状态
            beanclass:'',//任务路径
            dealtstatus:'',//处理状态
        },
        searchP2:{
            isplaysucceed:'',//任务状态
            starttime:'',//开始时间
            endtime:'',//结束时间
        },
        list: [], //table中的list显示数据
        pagination: {
            
        }, //分页相关的信息
        record: {}, //根据id查询的数据详情信息
    },

    getters: {
        getDomainnameSelectOptions(state) {
            return state.domainnameSelectOptions
        }
    },

    mutations: {
        save(state, action) {
            // console.log(action, "commit")
            // state = { ...state, ...action.payload }   //这么写不行，必须要遍历挨个重新赋值
            // state.domainnameSelectOptions = action.payload.domainnameSelectOptions
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
            // console.log(state, " yo ?") //跟console.log({ ...state, ...action.payload }) 的值是不一样的, 所以不能直接用展开运算符
        }
    },

    actions: {
        //查询系统列表信息
        selectTask(context, payload) {
            payload.type = 'timetask/selectTask'
            return D.select({
                ...payload
            })

        },
        //查询 执行记录列表
        selectHistory(context, payload) {
            payload.type = 'timetask/selectHistory'
            return D.select({
                ...payload
            })
        },
        //删除定时任务
        deleteTask(context, payload) {
            payload.type = 'timetask/deleteTask'
            return D.del({
                ...payload
            })
        },

        //解锁
        unlockTask(context, payload) {
            payload.type = 'timetask/unlockTask'
            return D.del({
                ...payload
            })
        },
      
        //开启/关闭
        startTask(context, payload) {
            return D.del({
                ...payload
            })
        },

        //编辑，查看
        detailTask(context, payload) {
            payload.apikey = 'timetask/detailTask'
            return D.detail({
                ...payload
            }).then(response => {
                const { data } = response.data;
                data.nchecked = data.isconcurrent == '1';
                context.commit({
                    type: 'save',
                    payload: {
                        record: data
                    }
                })
                return response
            })
  
        },
        getEmptyTask(context){
            context.commit({
                type: 'save',
                payload: {
                    record: {}
                }
            })
        },
        getEmptySearch(context){
            context.commit({
                type: 'save',
                payload: {
                    searchP: {
                        jobgroup:'',
                        jobname:'',
                        jobstatus:'',
                        beanclass:'',
                        dealtstatus:'',
                    }
                }
            })
        },
        getEmptyHistorySearch(context){
            context.commit({
                type: 'save',
                payload: {
                    searchP2: {
                        endtime:'',
                        starttime:'',
                        jobstatus:'',
                    }
                }
            })
        },
        // 更新任务
        updateTask(context, payload) {
            payload.type = 'timetask/updateTask'
            return D.edit({
                ...payload
            })
        },
        addTask(context, payload) {
            payload.type = 'timetask/addTask'
            return D.add({
                ...payload
            })
        },

        //查询不同
        querydifpage(context, payload) {
            return D.select({
                ...payload
            })
        },

        coverone(context, payload) {
            return D.edit({
                ...payload
            })
        },

        coverall(context, payload) {
            return D.select({
                ...payload
            })
        },
        
    }
}